import Select from 'react-select';
import { Input } from 'reactstrap';
import React, { useState } from 'react';
import { APIClient } from '../../helpers/api_helper';

export const SelectInputWithSearchApi = ({
  invalid,
  validation,
  setValue = () => {},
  handleChange = () => {},
}) => {
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);

  const api = new APIClient();

  const loadOptions = async (search) => {
    setLoading(true);
    const response = await api.create('/city/find', {
      q: search,
    });
    const result = response;
    setOptions(
      await result.map((permission) => ({
        label: permission.text,
        value: permission.id,
      }))
    );
    setLoading(false);
  };

  const styles = {
    control: () => ({
      display: 'flex',
      alignItems: 'center',
      height: 20,
      marginLeft: -10,
    }),
  };

  return (
    <Input
      tag={Select}
      styles={styles}
      invalid={invalid}
      noOptionsMessage={() => 'Sem resultado!'}
      isClearable={true}
      placeholder="Selecione uma cidade"
      value={validation.values.cityInput}
      onInputChange={(search) => {
        if (search.length === 1) {
          loadOptions(search);
        }
      }}
      loadingMessage={() => 'Carregando...'}
      isLoading={loading}
      onChange={(e) => {
        const event = {
          target: {
            name: 'cityInput',
            value: e,
          },
        };
        setValue(e);
        validation.handleChange(event);
        handleChange(e);
      }}
      onBlur={validation.handleBlur}
      options={options}
      inputId="cityInput"
      components={{
        IndicatorSeparator: () => null,
      }}
    />
  );
};
